import { v4 } from 'uuid'

export function generateMemberId() {
  return v4()
}
